import GeneratedTaskBoardStore from "./generated/GeneratedTaskBoardStore"

class TaskBoardStore extends GeneratedTaskBoardStore {

}

export const taskBoardStore = new TaskBoardStore()
